import { create } from 'zustand';

const useUiEffectsStore = create((set) => ({
  // Estado
  isTitleVisible: false,
  titleText: '',

  // Acción para mostrar el título
  showBigTitle: (text, duration = 4000) => {
    // 1. Establecemos el texto y hacemos visible el título
    set({ titleText: text, isTitleVisible: true });

    // 2. Programamos un temporizador para ocultarlo después
    setTimeout(() => {
      set({ isTitleVisible: false });
    }, duration);
  },
}));

export default useUiEffectsStore;